module.exports = __webpack_public_path__ + "static/media/zhuzijianshan_plant.d0b7b730.webp";